import gql from 'graphql-tag';

const CREATE_BUSINESS_FUNCTION = gql`
  mutation createBusinessFunction($input: BusinessFunctionInput!) {
    createBusinessFunction(input: $input) {
      businessFunctionId
      name
      head {
        userId
        name
      }
    }
  }
`;
const UPDATE_BUSINESS_FUNCTION = gql`
  mutation updateBusinessFunction($input: BusinessFunctionInput!) {
    updateBusinessFunction(input: $input) {
      businessFunctionId
      name
      head {
        userId
        name
      }
    }
  }
`;
const DELETE_BUSINESS_FUNCTION = gql`
  mutation deleteBusinessFunctions(
    $input: [BusinessFunctionIdentifierInput!]!
  ) {
    deleteBusinessFunctions(input: $input)
  }
`;
const CREATE_COMPANY_SITE = gql`
  mutation($input: CreateSiteInput!) {
    createCompanySite(input: $input) {
      id
      name
      businessHour {
        day
        start
        end
      }
      holidayList {
        id
        name
      }
      timezoneCode
      working24x7
      contactNumber
      account {
        accountId
        name
      }
      hq
      installerInfo {
        id
        installerName
        installerDownloadUrl
        os
      }
      address {
        addressId
        name
        line1
        line2
        line3
        city
        postalCode
        countryCode
        stateCode
      }
    }
  }
`;
const UPDATE_COMPANT_SITE = gql`
  mutation($input: UpdateSiteInput!) {
    updateCompanySite(input: $input) {
      id
      name
      businessHour {
        day
        start
        end
      }
      holidayList {
        id
        name
      }
      timezoneCode
      working24x7
      contactNumber
      account {
        accountId
        name
      }
      hq
      installerInfo {
        id
        installerName
        installerDownloadUrl
      }
      address {
        addressId
        line1
        line2
        line3
        city
        postalCode
        countryCode
        stateCode
      }
      emailDomains
    }
  }
`;
const DETELE_COMPANY_SITES = gql`
  mutation($input: [SiteIdentifierInput!]!) {
    deleteCompanySites(input: $input)
  }
`;
export {
  CREATE_BUSINESS_FUNCTION,
  DELETE_BUSINESS_FUNCTION,
  UPDATE_BUSINESS_FUNCTION,
  CREATE_COMPANY_SITE,
  DETELE_COMPANY_SITES,
  UPDATE_COMPANT_SITE
};
